import React from 'react';

function PrivacyPolicy() {
    return (
        <div className="bg-white py-12 md:py-16 px-4">
            <div className="max-w-4xl mx-auto">
                <h1 className="text-3xl md:text-4xl font-bold mb-8 text-gray-900">Privacy Policy</h1>
                <p className="text-gray-600 mb-8">Last Updated: August 21, 2025</p>
                
                <div className="prose prose-lg max-w-none text-gray-700">
                    <p>
                        At Faster Bike Taxi, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our mobile application and website.
                    </p>
                    
                    <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-900">Information We Collect</h2>
                    <p>We may collect information about you in a variety of ways:</p>
                    <ul className="list-disc pl-6 space-y-2 my-4">
                        <li>
                            <strong>Personal Data:</strong> While using our service, we may ask you to provide certain personally identifiable information such as your name, phone number, email address, mailing address, payment information, and location data that can be used to contact or identify you.
                        </li>
                        <li>
                            <strong>Usage Data:</strong> We may also collect information on how the service is accessed and used. This data may include information such as your computer's Internet Protocol address, browser type, browser version, the pages of our service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers, and other diagnostic data.
                        </li>
                        <li>
                            <strong>Location Data:</strong> We collect real-time information about the location of your device to provide our transportation services. This information is essential for connecting you with nearby drivers.
                        </li>
                    </ul>
                    
                    <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-900">How We Use Your Information</h2>
                    <p>We use the information we collect for various purposes:</p>
                    <ul className="list-disc pl-6 space-y-2 my-4">
                        <li>To provide and maintain our service</li>
                        <li>To notify you about changes to our service</li>
                        <li>To allow you to participate in interactive features when you choose to do so</li>
                        <li>To provide customer support</li>
                        <li>To gather analysis or valuable information so that we can improve our service</li>
                        <li>To monitor the usage of our service</li>
                        <li>To detect, prevent and address technical issues</li>
                        <li>To process payments for our services</li>
                        <li>To fulfill any other purpose for which you provide it</li>
                    </ul>
                    
                    <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-900">Disclosure of Your Information</h2>
                    <p>We may share your personal information in the following situations:</p>
                    <ul className="list-disc pl-6 space-y-2 my-4">
                        <li>
                            <strong>With Service Providers:</strong> We may share your information with third-party vendors, service providers, contractors, or agents who perform services for us or on our behalf.
                        </li>
                        <li>
                            <strong>For Business Transfers:</strong> We may share or transfer your information in connection with, or during negotiations of, any merger, sale of company assets, financing, or acquisition of all or a portion of our business to another company.
                        </li>
                        <li>
                            <strong>With Your Consent:</strong> We may disclose your personal information for any other purpose with your consent.
                        </li>
                        <li>
                            <strong>With Law Enforcement:</strong> Under certain circumstances, we may be required to disclose your personal information if required to do so by law or in response to valid requests by public authorities.
                        </li>
                    </ul>
                    
                    <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-900">Security of Your Data</h2>
                    <p>
                        The security of your data is important to us, but remember that no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your personal information, we cannot guarantee its absolute security.
                    </p>
                    
                    <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-900">Your Data Protection Rights</h2>
                    <p>You have certain data protection rights including:</p>
                    <ul className="list-disc pl-6 space-y-2 my-4">
                        <li>The right to access, update, or delete the information we have on you</li>
                        <li>The right of rectification - the right to have your information corrected if it is inaccurate or incomplete</li>
                        <li>The right to object to our processing of your personal data</li>
                        <li>The right of restriction - the right to request that we restrict the processing of your personal information</li>
                        <li>The right to data portability - the right to be provided with a copy of the information we have on you in a structured, machine-readable, and commonly used format</li>
                        <li>The right to withdraw consent at any time where we relied on your consent to process your personal information</li>
                    </ul>
                    
                    <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-900">Children's Privacy</h2>
                    <p>
                        Our services are not intended for use by children under the age of 18. We do not knowingly collect personally identifiable information from children under 18. If you are a parent or guardian and you are aware that your child has provided us with personal data, please contact us.
                    </p>
                    
                    <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-900">Changes to This Privacy Policy</h2>
                    <p>
                        We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date at the top of this Privacy Policy. You are advised to review this Privacy Policy periodically for any changes.
                    </p>
                    
                    <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-900">Contact Us</h2>
                    <p>
                        If you have any questions about this Privacy Policy, please contact us:
                    </p>
                    <ul className="list-disc pl-6 space-y-2 my-4">
                        <li>By email: privacy@fasterbiketaxi.com</li>
                        <li>By phone: (123) 456-7890</li>
                        <li>By mail: 123 Main Street, Bangalore, India</li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default PrivacyPolicy;
